export const delayTime = 600

export const fadedelayTime = 1000

export const slideDirection = "right"
export const slideDirectionEPM = "left"